import { TripContext } from 'contexts';
import React, { FC, Fragment, useContext } from 'react';
import { useOrderItemService } from 'services';
import { ReconcileReasonType, Temperature } from 'services/enums';
import { LineItem, OrderItem, OrderItemChange } from 'services/types';
import './recap-summary.scss';

type Props = {
    items: OrderItem[],
}

export const RecapSummary: FC<Props> = ({ items }) => {
    const tripContext = useContext(TripContext)
    const { calculatedeliveredQuantity } = useOrderItemService()

    const changes: OrderItemChange[] = tripContext.orderItemChanges.toArray() ?? []
    const lineItems: LineItem[] = tripContext.lineItems.toArray() ?? []

    let deliveredQuantityDry: number = 0
    let deliveredQuantityFrozen: number = 0
    let deliveredQuantityRefrigerated: number = 0

    items.forEach(item => {
        let calculateDeliveredQuantityResult = calculatedeliveredQuantity(item, deliveredQuantityDry, deliveredQuantityFrozen, deliveredQuantityRefrigerated)
        deliveredQuantityDry = calculateDeliveredQuantityResult.deliveredQuantityDry
        deliveredQuantityFrozen = calculateDeliveredQuantityResult.deliveredQuantityFrozen
        deliveredQuantityRefrigerated = calculateDeliveredQuantityResult.deliveredQuantityRefrigerated
    })

    const calculateTotal = (items: OrderItem[]): number => {
        let total: number = 0;
        if (items && items.length > 0)
            total = items.reduce((total, currentValue) => total = total + currentValue.orderedQuantity, 0);
        return total;
    }

    return (
        <Fragment>
            <div className="recap-summary-row">
                <div className="recap-summary-horizontal total">Stop Totals</div>
                <div className="recap-summary-horizontal">Ordered</div>
                <div className="recap-summary-horizontal">Delivered</div>
            </div>
            <div className="recap-summary-row">
                <div className="recap-summary-heading">Dry</div>
                <div className="recap-summary-content">{calculateTotal(items.filter(x => lineItems.some(li => li.id === x.lineItemId && li.temperature === Temperature.Dry)))}</div>
                <div className="recap-summary-content">{deliveredQuantityDry}</div>
            </div>
            <div className="recap-summary-row">
                <div className="recap-summary-heading">Ref</div>
                <div className="recap-summary-content">{calculateTotal(items.filter(x => lineItems.some(li => li.id === x.lineItemId && li.temperature === Temperature.Refrigerated)))}</div>
                <div className="recap-summary-content">{deliveredQuantityRefrigerated}</div>
            </div>
            <div className="recap-summary-row">
                <div className="recap-summary-heading">Frz</div>
                <div className="recap-summary-content">{calculateTotal(items.filter(x => lineItems.some(li => li.id === x.lineItemId && li.temperature === Temperature.Frozen)))}</div>
                <div className="recap-summary-content">{deliveredQuantityFrozen}</div>
            </div>
            <div className="recap-summary-row">
                <div className="recap-summary-heading highlight">Total</div>
                <div className="recap-summary-content highlight">  {calculateTotal(items)} </div>
                <div className="recap-summary-content highlight"> {(deliveredQuantityDry + deliveredQuantityFrozen + deliveredQuantityRefrigerated)} </div>
            </div>
        </Fragment>
    );
}